<div class="account">
  <div class="box">
    <div class="logo"><img src="{{glob.host}}filer/logo_login"></div>
    <label class="title">سیستم تولید نرم افزار پدیرا</label>
    <br><br>
    <label class="form-title">فرم ثبت حساب کاربری</label>
    <br><br>
    <div class="form-group">
      <input type="text" id="email" [(ngModel)]="email" placeholder="ایمیل" autocomplete="off">
    </div>
    <div class="form-group">
      <input type="password" id="password" [(ngModel)]="password" placeholder="رمز عبور" autocomplete="off">
    </div>
    <div class="form-group">
      <select [(ngModel)]="cplan_id" (change)="plan_change($event)" title="طرح ها" placeholder="طرح ها">
        <option value="null">طرح ها</option>
        <option *ngFor="let p of plan" value="{{p.id}}">{{p.tit}}</option>
      </select>
    </div>
    <div class="form-group">
      <select [(ngModel)]="count" (change)="plan_change($event)" *ngIf="cplan && cplan.no!=0">
        <option value="1">یک ماهه</option>
        <option value="3">سه ماهه</option>
        <option value="6">شش ماهه</option>
        <option value="12">دوازده ماهه</option>
      </select>
    </div>
    <div class="form-group" *ngIf="cplan" class="info">
      <label>مدت استفاده: &nbsp;</label> <span>{{cplan.no==0?'7 روز':'نا محدود'}}</span><br>
      <label>حداکثر تعداد جدول: &nbsp;</label> <span>{{cplan.max_tables}}</span><br>
      <label>هزینه:&nbsp;</label> <span>{{cost}}</span>
    </div>
    <div class="form-group">
      <button class="btn" type="button" *ngIf="cplan && cplan.no==0" (click)="register()">ثبت حساب کاربری</button>
      <button class="btn" type="button" *ngIf="cplan && cplan.no!=0 && count" (click)="payment()">پرداخت سفارش</button> &nbsp;
    </div>
    <a routerLink="/account/login">ورود به سیستم</a>
    <div class="effect_box"></div>
  </div>
  <div class="effect_account"></div>
</div>